import { render, staticRenderFns } from "./StatusChangeButton.vue?vue&type=template&id=b9618446"
import script from "./StatusChangeButton.vue?vue&type=script&lang=js"
export * from "./StatusChangeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports